import { Stack } from "@mui/material";
import React, { useEffect } from "react";
import CycleSummaryContainer from "./CycleSummary/CycleSummaryContainer";
import CycleReportContainer from "./CycleReport/CycleReportContainer";
import BioChallengePanel from "./BioChallenge/BioChallengePanel";
import Grid from "@mui/material/Unstable_Grid2";
import { useDispatch, useSelector } from "react-redux";
import {
    fetchBiochallengeInfo,
    fetchCustomerDevices,
    fetchDeviceCycles,
    isFacilityAirport,
    setDeviceConfigId,
    setSelectedDevice,
} from "./deviceDashboardSlice";

import Toolbar from "./Toolbar/Toolbar";
import NoCycles from "./NoCycles/NoCycles";
import MainCard from "src/components/material/Cards/MainCard";
import CyclesByOperatorContainer from "./CyclesByOperator/CyclesByOperatorContainer";
import SterilizationInfoContainer from "./SterilizationInfo/SterilizationInfoContainer";
import WasteProcessedContainer from "./WasteProcessed/WasteProcessedContainer";


const DeviceDashboard = (props) => {
    const {
        deviceConfigId,
        deviceSerial,
        noCyclesFound,
        customerDevices,
        biochallengeInfo,
        deviceTimezone,
        userTimezone,
        // @ts-ignore
    } = useSelector((store) => store.devicedashboard);

    document.title = `${deviceSerial} Dashboard`;
    const dispatch = useDispatch();

    const isAirport = useSelector((store) => isFacilityAirport(store.devicedashboard));

    useEffect(() => {
        // @ts-ignore
        dispatch(fetchCustomerDevices());
    }, []);

    useEffect(() => {
        dispatch(setDeviceConfigId(Number(props.match.params["device_id"]) || deviceConfigId));
        dispatch(setSelectedDevice(customerDevices.find((device) => device.id === deviceConfigId)));
    }, [customerDevices]);

    useEffect(() => {
        if (deviceConfigId) {
            // @ts-ignore
            dispatch(fetchDeviceCycles());
            // @ts-ignore
            dispatch(fetchBiochallengeInfo());
            dispatch(setSelectedDevice(customerDevices.find((device) => device.id === deviceConfigId)));
        }
    }, [deviceConfigId]);

    return (
        <MainCard>
            <Toolbar />
            {noCyclesFound ? (
                <NoCycles />
            ) : (
                <Grid container spacing={2}>
                    <Grid xs={12} lg={5} sx={{ display: "flex" }}>
                        <CycleSummaryContainer />
                    </Grid>
                    <Grid xs={12} md={6} lg={3} sx={{ display: "flex" }}>
                        <CyclesByOperatorContainer />
                    </Grid>
                    <Grid xs={12} md={6} lg={4} sx={{ display: "flex" }}>
                        <WasteProcessedContainer />
                    </Grid>
                    <Grid xs={12} lg={8} sx={{ display: "flex" }}>
                        <CycleReportContainer />
                    </Grid>
                    <Grid xs={12} lg={4} sx={{ display: "flex" }}>
                        <Stack direction={"column"} spacing={2} width={"100%"}>
                            <SterilizationInfoContainer />
                            {isAirport ? null : <BioChallengePanel biochallengeInfo={biochallengeInfo} deviceTimezone={deviceTimezone} userTimezone={userTimezone} />}
                        </Stack>
                    </Grid>
                    <Grid xs={4} sx={{ display: "flex" }}></Grid>
                </Grid>
            )}
        </MainCard>
    );
};

export default DeviceDashboard;
